(function () {
    'use strict';

    angular
        .module('showcaseApp')
        .component('importFlyerListCard', {
            templateUrl: 'app/admin/flyers/import-hub/select-flyers/import-flyer-list-card/import-flyer-list-card.html',
            controller: importFlyerListCardController,
            bindings: {
                flyer: '<',
                bucket: '<',
                currencyInstance: '<',
                checkboxIsChecked: '<',
                checkboxClick: '&',
                isImmoContext: '<',
                isImportFromHub: '<'
            }
        });

    /** @ngInject */
    function importFlyerListCardController($rootScope, systemConstants) {
        var $ctrl = this;
        $ctrl.isImportFromHub = $ctrl.isImportFromHub !== undefined ? $ctrl.isImportFromHub: true;
        var coverImageResolution = systemConstants.IMAGE_RESOLUTIONS.LIST_CARD;
        var groupedImage = getGroupedCoverImage($ctrl.flyer, coverImageResolution);

        if (groupedImage) {
            $ctrl.coverImage = groupedImage;
        } else {
            $ctrl.coverImage = $ctrl.isImportFromHub ?
                getHubFlyerImageWithResolution($ctrl.flyer, coverImageResolution)
                : getFlyerImageWithResolution($ctrl.flyer, coverImageResolution);
        }
    }
})();
